module.exports = __webpack_public_path__ + "static/sport/tag-login.56c2415.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport8/tag-login.png
// module id = Z3sW
// module chunks = 0